module.exports = __webpack_public_path__ + "img/update.a7ad44e5.svg";